import { GetMeQuery } from "@typing/Generated";

type MyClient = Extract<GetMeQuery["me"], { __typename: "Client" }>;
type MyExpert = Extract<GetMeQuery["me"], { __typename: "Expert" }>;

interface JourneyRouteBasic {
  journeyId: string;
  linkAfterJourney: string;
  preventScroll?: boolean;
}

interface JourneyRouteWithClient extends JourneyRouteBasic {
  myClient: MyClient | undefined;
  myExpert?: null;
}

interface JourneyRouteWithExpert extends JourneyRouteBasic {
  myClient?: null;
  myExpert: MyExpert | undefined;
}

type JourneyRoute = JourneyRouteWithClient | JourneyRouteWithExpert;

export const journeyRoute = ({ preventScroll = true, ...props }: JourneyRoute) => {
  let scrollParam = "";

  if (preventScroll) {
    scrollParam = props.linkAfterJourney.includes("?") ? `&ps=true` : "?ps=true";
  }

  let userType = "client";

  if ((Object.keys(props).includes("myClient") && !props.myClient) || props.myExpert) {
    userType = "expert";
  }

  return `/${userType}/journeys/${props.journeyId}${props.linkAfterJourney}${scrollParam}`;
};
